var map = {
	"./akcje-czy-etf.md": [
		"fa0c",
		"chunk-2d237124"
	],
	"./banki-na-gpw.md": [
		"119c",
		"chunk-2d0aa660"
	],
	"./brokerzy-podatki.md": [
		"45a9",
		"chunk-2d0c172f"
	],
	"./freedom24-recenzja.md": [
		"b450",
		"chunk-2d20f723"
	],
	"./gdzie-kupic-chinskie-akcje.md": [
		"1361",
		"chunk-2d0aad53"
	],
	"./godziny-otwarcia-gield.md": [
		"5e4e",
		"chunk-2d0d3a77"
	],
	"./inwestowanie-w-faang.md": [
		"9567",
		"chunk-2d0e57d3"
	],
	"./inwestowanie-w-obligacje.md": [
		"8e49",
		"chunk-2d0e9768"
	],
	"./inwestowanie-w-sp500.md": [
		"160d",
		"chunk-2d0ab80f"
	],
	"./jak-inwestowac-na-gieldzie-w-usa.md": [
		"e78f",
		"chunk-2d226016"
	],
	"./jak-inwestowac-w-ai.md": [
		"b3b0",
		"chunk-2d20f8d5"
	],
	"./jak-inwestowac-w-branze-biotech.md": [
		"7920",
		"chunk-2d0d7d96"
	],
	"./jak-inwestowac-w-branze-gamingowa.md": [
		"e16d",
		"chunk-2d224950"
	],
	"./jak-inwestowac-w-branze-motoryzacyjna.md": [
		"4ec1",
		"chunk-2d0ccb95"
	],
	"./jak-inwestowac-w-dow-jones.md": [
		"6138",
		"chunk-2d0ceb56"
	],
	"./jak-inwestowac-w-nieruchomosci-na-gieldzie.md": [
		"651f",
		"chunk-2d0cfa4a"
	],
	"./jak-inwestowac-w-opcje.md": [
		"ed66",
		"chunk-2d230895"
	],
	"./jak-inwestowac-w-oze-na-gieldzie.md": [
		"a984",
		"chunk-2d2095ea"
	],
	"./jak-inwestowac-w-rope.md": [
		"39f6",
		"chunk-2d0bb26c"
	],
	"./jak-inwestowac-w-zloto.md": [
		"998f",
		"chunk-2d0e6744"
	],
	"./jak-kupic-akcje-alibaba.md": [
		"dfa0",
		"chunk-2d22a0e7"
	],
	"./jak-kupic-akcje-allegro.md": [
		"5fe5",
		"chunk-2d0d43f7"
	],
	"./jak-kupic-akcje-amazon.md": [
		"d9dd",
		"chunk-2d21f88b"
	],
	"./jak-kupic-akcje-apple.md": [
		"2d32",
		"chunk-2d0bd947"
	],
	"./jak-kupic-akcje-biedronki.md": [
		"19aa0",
		"chunk-744e5eb2"
	],
	"./jak-kupic-akcje-bmw.md": [
		"c015",
		"chunk-2d215c07"
	],
	"./jak-kupic-akcje-budimexu.md": [
		"d6f0",
		"chunk-2d21ed52"
	],
	"./jak-kupic-akcje-cd-projekt.md": [
		"2a50",
		"chunk-2d0bce40"
	],
	"./jak-kupic-akcje-coca-cola.md": [
		"f2d6",
		"chunk-2d22c6d4"
	],
	"./jak-kupic-akcje-dino.md": [
		"778d",
		"chunk-2d0d7702"
	],
	"./jak-kupic-akcje-ebay.md": [
		"4df45",
		"chunk-748c3e81"
	],
	"./jak-kupic-akcje-enea.md": [
		"b172",
		"chunk-2d20ec20"
	],
	"./jak-kupic-akcje-epic-games.md": [
		"fd94",
		"chunk-2d237d4f"
	],
	"./jak-kupic-akcje-facebooka.md": [
		"2891",
		"chunk-2d0b34d4"
	],
	"./jak-kupic-akcje-ferrari.md": [
		"f446",
		"chunk-2d22c886"
	],
	"./jak-kupic-akcje-google.md": [
		"706f",
		"chunk-2d0d5c7f"
	],
	"./jak-kupic-akcje-gs.md": [
		"6e1e",
		"chunk-2d0dae79"
	],
	"./jak-kupic-akcje-inpost.md": [
		"5ab0",
		"chunk-2d0d30d0"
	],
	"./jak-kupic-akcje-johnson-and-johnson.md": [
		"681e",
		"chunk-2d0d058c"
	],
	"./jak-kupic-akcje-jsw.md": [
		"4cc0",
		"chunk-2d0cc412"
	],
	"./jak-kupic-akcje-kghm.md": [
		"d366",
		"chunk-2d21dc45"
	],
	"./jak-kupic-akcje-lpp.md": [
		"758d",
		"chunk-2d0d6f80"
	],
	"./jak-kupic-akcje-microsoft.md": [
		"f93d",
		"chunk-2d22db5a"
	],
	"./jak-kupic-akcje-netflix.md": [
		"5d58",
		"chunk-2d0d36a8"
	],
	"./jak-kupic-akcje-nike.md": [
		"d6c7",
		"chunk-2d21ecfc"
	],
	"./jak-kupic-akcje-nvidia.md": [
		"e75e",
		"chunk-2d225fb8"
	],
	"./jak-kupic-akcje-orlen.md": [
		"dd98",
		"chunk-2d229495"
	],
	"./jak-kupic-akcje-paypal.md": [
		"1003",
		"chunk-2d0aa158"
	],
	"./jak-kupic-akcje-pgz.md": [
		"e9dc",
		"chunk-2d226ce9"
	],
	"./jak-kupic-akcje-pzu.md": [
		"fc29",
		"chunk-2d2378ba"
	],
	"./jak-kupic-akcje-roblox.md": [
		"9724",
		"chunk-2d0e5ed6"
	],
	"./jak-kupic-akcje-saudi-aramco.md": [
		"0401",
		"chunk-2d0a3bfb"
	],
	"./jak-kupic-akcje-sony.md": [
		"154c",
		"chunk-2d0ab4c9"
	],
	"./jak-kupic-akcje-tesla.md": [
		"c175",
		"chunk-2d216082"
	],
	"./jak-kupic-akcje-uber.md": [
		"604b",
		"chunk-2d0ce7de"
	],
	"./jak-kupic-akcje-ulamkowe.md": [
		"a56a",
		"chunk-2d2086d5"
	],
	"./jak-kupic-akcje-xiaomi.md": [
		"4e9d",
		"chunk-2d0cc6b2"
	],
	"./jak-kupic-akcje-xtb.md": [
		"ac87",
		"chunk-2d213397"
	],
	"./jak-kupic-japonskie-akcje.md": [
		"0ef8",
		"chunk-2d0afa7d"
	],
	"./jak-kupic-niemieckie-akcje.md": [
		"d838",
		"chunk-2d21eeaf"
	],
	"./jak-kupic-surowce.md": [
		"c6be",
		"chunk-2d2178ac"
	],
	"./jak-wybrac-brokera.md": [
		"7733",
		"chunk-2d0d7636"
	],
	"./jak-wybrac-etf.md": [
		"e1a3",
		"chunk-2d224e54"
	],
	"./na-czym-polega-inwestowanie-pasywne.md": [
		"f611",
		"chunk-2d22cfa6"
	],
	"./najlepsze-konto-demo.md": [
		"75a3",
		"chunk-2d0d7446"
	],
	"./najwieksze-spolki-gpw-2024.md": [
		"6c5a",
		"chunk-2d0da76f"
	],
	"./najwieksze-spolki-na-gpw.md": [
		"f70a",
		"chunk-2d22d378"
	],
	"./najwieksze-spolki-nasdaq-2024.md": [
		"61fa",
		"chunk-2d0cf1ac"
	],
	"./najwieksze-spolki-xetra.md": [
		"40ee",
		"chunk-2d0c0512"
	],
	"./oprocentowanie-wolnych-srodkow.md": [
		"9193",
		"chunk-2d0e4928"
	],
	"./pary-walut.md": [
		"61d3",
		"chunk-2d0cf140"
	],
	"./plany-inwestycyjne.md": [
		"b726",
		"chunk-2d21020f"
	],
	"./podatek-od-zyskow-z-gield-zagranicznych.md": [
		"d85e",
		"chunk-2d21ef1a"
	],
	"./promocja-kalkulatorgieldowy.md": [
		"9591",
		"chunk-2d0e582a"
	],
	"./recenzja-nsbroker.md": [
		"46f6",
		"chunk-2d0c1b88"
	],
	"./spolki-dywidendowe.md": [
		"80ca",
		"chunk-2d0dd64c"
	],
	"./spolki-nyse.md": [
		"b792",
		"chunk-2d2102e4"
	],
	"./wady-zalety-cfd.md": [
		"6705",
		"chunk-2d0d017c"
	],
	"./wskazniki-gieldowe.md": [
		"7ca7",
		"chunk-2d0e20f8"
	],
	"./wygrana-trumpa-2024.md": [
		"edf4",
		"chunk-2d230e63"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ffe3";
module.exports = webpackAsyncContext;